import React from "react";
import { PageHero, Section } from "@/components/PageParts";
import CommissionCalculator from "@/components/CommissionCalculator";
import { ComplianceNotice } from "@/components/Disclaimers";

export default function CommissionCalculatorPage() {
  return (
    <div>
      <PageHero eyebrow="Commission calculator" title="Model illustrative placement economics"
        subtitle="Every provider and service category can have a different compensation formula. Adjust the inputs to explore illustrative scenarios. This platform never hard-codes a single percentage." />
      <Section className="py-16">
        <CommissionCalculator />
        <div className="mt-8">
          <ComplianceNotice />
        </div>
        <p className="mt-6 text-sm text-slate-500">
          Government-payer programs (Medicare, Medicaid, 1915(i), Innovations Waiver, TRICARE, CHAMPVA, CHIP, and other
          federal/state programs) are subject to a compliance gate: per-patient referral commissions are not calculated,
          advertised, or approved without appropriate compliance and legal review.
        </p>
      </Section>
    </div>
  );
}
